import { render, staticRenderFns } from "./UeTabs.vue?vue&type=template&id=43c07b41&"
import script from "./UeTabs.vue?vue&type=script&lang=js&"
export * from "./UeTabs.vue?vue&type=script&lang=js&"
import style0 from "./UeTabs.vue?vue&type=style&index=0&id=43c07b41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports